/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

enum AbrechnungAb {
    "RECHNUNGSERSTELLUNG" = "RECHNUNGSERSTELLUNG",
    "RECHNUNGSFREIGABE" = "RECHNUNGSFREIGABE",
}

export default AbrechnungAb;